module.exports = __webpack_public_path__ + "img/docs-outline.f4cf4746.svg";